import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import { rowsPerPage, rowsPerPageOptions } from '../utils/constants';

const Pagination = ({
  count,
  onPageChange,
  onRowsPerPageChange,
  pagination,
  rowsPerPageOptions: customRowsPerPageOptions
}) => (
  <TablePagination
    sx={{
      '& > .MuiToolbar-root': {
        '& > p': {
          mb: 0
        }
      }
    }}
    rowsPerPageOptions={customRowsPerPageOptions || rowsPerPageOptions}
    component="div"
    count={count}
    rowsPerPage={pagination.page_size || rowsPerPage}
    page={pagination.page - 1 || 0}
    onPageChange={onPageChange}
    onRowsPerPageChange={onRowsPerPageChange}
  />
);

export default Pagination;